/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { FC } from "react"
import { Select } from "@duxton-web/ui"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { actionCreator } from "store/store"
import { AppState } from "store/store.type"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"
import { useTranslationsMap } from "common/utils/i18n"
import styles from "./ItemPhotoSelect.modules.css"

export type ItemFilterType = "allItems" | "itemsWithoutPhoto"

export const ItemPhotoSelect: FC = () => {
  const dispatch = useDispatch()
  const { itemFilter } = useSelector(
    (state: AppState) => state.menu,
    shallowEqual,
  )

  const textMap = useTranslationsMap({
    allItems: "itemPhotoCoverage.filter.allItems",
    itemsWithoutPhoto: "itemPhotoCoverage.filter.withoutPhoto",
  })

  const handleChange = (value: ItemFilterType) => {
    dispatch(actionCreator.menu.itemFilter(value))
    if (value === "itemsWithoutPhoto") {
      TroyWebTracker.sendEvent({
        category: EventCategory.menuOverviewTab,
        action: EventAction.clickItemWithoutPhoto,
      })
    }
  }
  return (
    <Select
      defaultValue={itemFilter}
      onChange={handleChange}
      popupMatchSelectWidth={false}
      value={itemFilter}
      className={styles.itemPhotoSelect}
      popupClassName={styles.itemPhotoSelectDropdown}
      data-testid="item-photos-select"
    >
      <Select.Option value="allItems">{textMap.allItems}</Select.Option>
      <Select.Option value="itemsWithoutPhoto">
        {textMap.itemsWithoutPhoto}
      </Select.Option>
    </Select>
  )
}
